export default __webpack_public_path__ + "static/media/our_values_HIL.27dca127.png";